import React from 'react';
import { Link } from 'react-router-dom';

import './Header.scss';

function Header() {
  return (
    <header className="header--wrapper">
      <nav>
        <ul className="header--nav-list">
          <li className="header--nav-link is-title">
            <Link to="/">
              Monster<span>Save</span>
            </Link>
          </li>
          <li className="header--nav-link">
            <Link to="/world">Worlds</Link>
          </li>
          <li className="header--nav-link">
            <Link to="/all">All sims</Link>
          </li>
          <li className="header--nav-link u-small">
            <Link to="/list">Other links</Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
